<template>
  <div>
    <v-select
      v-model="selectedPlace"
      placeholder="Start typing to search"
      label="description"
      :options="places"
      :reduce="opt => opt.place_id"
      class="mb-2"
      @search="fetchPlaces"
      @input="onSelectedPlace"
    />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="setMarkerLoading"
    >
      <div id="endTripLocationMap" />
    </b-overlay>
    <b-button
      block
      class="mt-2"
      :disabled="endTripLoading || (!selectedLat && !selectedLng)"
      variant="primary"
      @click="endTrip"
    >
      End Trip
    </b-button>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import vSelect from 'vue-select'
import { onMounted, ref } from '@vue/composition-api'
import { debounce } from 'lodash'
import { BOverlay, BButton } from 'bootstrap-vue'

export default {
  components: {
    vSelect,
    BOverlay,
    BButton,
  },
  setup(_, ctx) {
    const selectedPlace = ref(null)
    const selectedLat = ref(null)
    const selectedLng = ref(null)
    const map = ref(null)
    const setMarkerLoading = ref(false)
    const createMarker = () => {
      const marker = new google.maps.Marker({
        position: {
          lat: selectedLat.value,
          lng: selectedLng.value,
        },
      })
      marker.setMap(map.value)
      map.value.setCenter({
        lat: selectedLat.value,
        lng: selectedLng.value,
      })
    }
    function initMap() {
      const center = {
        lat: 31.963158, lng: 35.930359,
      }
      map.value = new google.maps.Map(document.getElementById('endTripLocationMap'), {
        zoom: 15,
        center,
      })
    }
    const places = ref([])
    const fetchPlaces = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      const res = await ctx.root.$store.dispatch('trips/searchPlaces', {
        text: search,
      })
      places.value = res.data.data.places
      loading(false)
    }, 1000)
    const onSelectedPlace = async () => {
      setMarkerLoading.value = true
      const res = await ctx.root.$store.dispatch('trips/getPlaceLatLong', {
        placeId: selectedPlace.value,
      })
      const { location } = res.data.data.results.at(0).geometry
      selectedLat.value = location.lat
      selectedLng.value = location.lng
      createMarker()
      setMarkerLoading.value = false
    }
    const endTripLoading = ref(false)
    const endTrip = async () => {
      endTripLoading.value = true
      await ctx.root.$store.dispatch('trips/applyActionOnTrip', {
        action: 'end',
        actionDescription: undefined,
        actualDropoff: {
          latitude: selectedLat.value.toString(),
          longitude: selectedLng.value.toString(),
        },
      })
      endTripLoading.value = false
      ctx.root.$bvModal.hide('end-trip-modal')
    }
    onMounted(() => {
      initMap()
    })
    return {
      endTripLoading,
      endTrip,
      onSelectedPlace,
      fetchPlaces,
      places,
      setMarkerLoading,
      selectedPlace,
      selectedLat,
      selectedLng,
    }
  },
}
</script>

<style scoped>

#endTripLocationMap {
    width:100%;
    height: 400px;
}
</style>
